import Vue from 'vue'
import App from './App.vue'
import "./style/public.css";
import "./style/variables.scss";
import axios from 'axios'
import qs from 'qs';

import "@/assets/js/member-common.js";
// import VueI18n from './language';
import VueI18n from 'vue-i18n'
import '@/icons' // icon

Vue.use(VueI18n);
var i18n = new VueI18n({
    locale:'en',
    messages: {
        en:require('./language/en'),
        cs:require('./language/cs'),
        da:require('./language/da'),
        de:require('./language/de'),
        el:require('./language/el'),
        es:require('./language/es'),
        fi:require('./language/fi'),
        fr:require('./language/fr'),
        hu:require('./language/hu'),
        // ja:require('./language/ja'),
        it:require('./language/it'),
        ja:require('./language/ja'),
        nl:require('./language/nl'),
        no:require('./language/no'),
        pl:require('./language/pl'),
        pt:require('./language/pt'),
        ru:require('./language/ru'),
        sv:require('./language/sv'),
        tr:require('./language/tr'),
        "zh-tw":require('./language/zh-TW'),
        "zh-cn":require('./language/zh-CN'),
    }
})
window.i18nWaterMark=i18n
Vue.prototype.$qs = qs;
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// 添加响应拦截器
axios.interceptors.request.use(
	config => {
		if (config.method === 'post') {
			config.data = qs.stringify(config.data)
		}
		return config
	},
	error => {
		console.log(error)
		Promise.reject(error)
	}
)

new Vue({
	i18n,
  render: h => h(App),
}).$mount('#app')